<div class="confirm-dialog__header"
  mat-dialog-title>
  @if (titleDialog?.length > 0) {
    <h2>
      {{ titleDialog }}
    </h2>
  }
  <button class="close"
    data-e2e="confirm-dialog-close"
    (click)="dialogRef.close()"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<div class="confirm-dialog__content"
  [class.confirm-dialog__content--has-background]="background"
  [style]="background ? ('background-image: url(' + background + ')') : null"
  mat-dialog-content>
  <div [innerHTML]="bodyDialog"></div>
  @if (labelConfirmDialog?.length > 0) {
    <input matInput #inputToFocus [placeholder]="labelConfirmDialogPlaceHolder"
      [(ngModel)]="inputValue" type="text">
  }
  @if (isLengthInputTooLong()) {
    <mat-error>inputErrorLengthMessage</mat-error>
  }
</div>

<div class="confirm-dialog__actions"
  mat-dialog-actions>
  @if (labelConfirmDialog?.length > 0) {
    <button
      class="mat-accent mr-16"
      data-e2e="confirm-dialog-submit-input"
      mat-raised-button
      [disabled]="isLengthInputTooLong() || inputValue === originalInputValue || inputValue ==='' || inputValue === undefined || isInputInvalid()"
      (click)="dialogRef.close(inputValue)">
      <span>{{ labelConfirmDialog }}</span>
    </button>
  }
  @if (labelTrueDialog?.length > 0) {
    <button
      class="mat-accent mr-16 confirm-dialog__validate-button"
      data-e2e="confirm-dialog-validate"
      mat-raised-button
      (click)="dialogRef.close(true)">
      <span>{{ labelTrueDialog }}</span>
    </button>
  }
  @if (labelFalseDialog?.length > 0) {
    <button
      class="mr-16 confirm-dialog__cancel-button"
      data-e2e="confirm-dialog-cancel"
      [ngClass]="{'mat-accent':!(labelTrueDialog?.length > 0)}"
      mat-raised-button
      (click)="dialogRef.close(false)">
      <span>{{ labelFalseDialog }}</span>
    </button>
  }
  @if (labelOtherDialog?.length > 0) {
    <button
      class="mr-16"
      data-e2e="confirm-dialog-other-action"
      [ngClass]="{'mat-accent':!(labelOtherDialog?.length > 0)}"
      mat-raised-button
      (click)="dialogRef.close('otherButtonDialogAction')">
      <span>{{ labelOtherDialog }}</span>
    </button>
  }
  @if (showReportbutton) {
    <app-error-reporting-trigger-button
      [type]="'resource'"
      [activityId]="resourceId"
      [objectTitle]="titleDialog">
    </app-error-reporting-trigger-button>
  }
</div>
